// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".conditionAgreementContent {\n  line-height: 20px;\n  letter-spacing: -0.32px;\n}\n", "",{"version":3,"sources":["webpack://./src/app/logic/ConditionAgreementFormItem.less"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,uBAAA;AACJ","sourcesContent":[".conditionAgreementContent {\n    line-height: 20px;\n    letter-spacing: -0.32px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
